// extracted by mini-css-extract-plugin
export var courseIsChosen = "category-course-pill-module--course-is-chosen--k4l2y";
export var hoverNotCurrent = "category-course-pill-module--hover-not-current--WVbY0";
export var listCounter = "category-course-pill-module--list-counter--Alui9";
export var title = "category-course-pill-module--title--yqjP4";
export var wrapper = "category-course-pill-module--wrapper--93qDm";